// services/chatBlockPosition.ts
//
// The QBank block position a user message's context label carries (ORA-1285).
// Both the stream parser and the conversation parser read it, so it lives on
// its own: the stream parser must stay free of the axios client.

import type { ChatBlockPosition } from '@/types/chatStream';

const positiveInteger = (value: unknown): number | null =>
  typeof value === 'number' && Number.isInteger(value) && value > 0
    ? value
    : null;

/** A position, or undefined when the value is not one this client trusts. */
export const parseChatBlockPosition = (
  value: unknown
): ChatBlockPosition | undefined => {
  if (typeof value !== 'object' || value === null || Array.isArray(value))
    return undefined;

  const raw = value as Record<string, unknown>;
  const index = positiveInteger(raw.index);
  const total = positiveInteger(raw.total);

  if (index === null || total === null || index > total) return undefined;

  return { index, total };
};
